import type { JSX } from 'react';

import { Container } from '@change-corgi/design-system/layout';

import { PageBanner } from '../components/PageBanner';
import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();

	return (
		<>
			<PageMeta />
			<PageBanner />
			<Container variant="small" px={8} pt={32} pb={32} sx={{ maxWidth: 800 }}>
				<PageHeading mb={32} />
				<PageBody />
			</Container>
		</>
	);
}
